<template>
  <card>
    <list
      v-if="$store.state.user.sections['orders']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="true"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      :createLog="true"
      @changeFunction="changeFunction"
      v-model="val"
      :projectInfo="2"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      staticFilters: [
        {
          title: "Статус партнеров",
          key: "partner_status",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "1",
              title: "В процессе",
            },
            {
              id: "2",
              title: "Отмененные",
            },
            {
              id: "3",
              title: "Выполненные",
            },
            {
              id: "4",
              title: "Без формирования оплаты",
            },
          ],
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "status",
          title: "Фильтр по статусам",
          titleKey: "status_filter",
          field_key: "status",
          selectKey: "name",
        },
        {
          key: "partner",
          title: "Фильтр по партнерам",
          titleKey: "partner_filter",
          field_key: "partner",
          selectKey: "name",
        },

        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "user_filter",
          field_key: "user",
          selectKey: "name",
        },
        {
          key: "client",
          title: "Фильтр по покупателям",
          titleKey: "client_filter",
          field_key: "client",
          selectKey: "phone",
        },
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "shop_filter",
          field_key: "shop",
          selectKey: "name",
        },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "organization_filter",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [
        {
          label: "Номер телефона покупателя",
          key: "phone",
          labelKey: "client_phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          label: "Имя покупателя",
          key: "first_name",
          labelKey: "client_first_name",
          type: "field",
        },
        {
          label: "Фамилия покупателя",
          key: "last_name",
          labelKey: "client_last_name",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          detail: true,

          // remove: true,
        },
        {
          key: "id",
          titleKey: "id",
          title: "Номер",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          title: "Фин. партнеры",
          key: "transactions",
          titleKey: "fin_partners",
          object: "state",
          disableLink: true,
        },
        {
          key: "client",
          titleKey: "client",
          object: "phone",
          title: "Клиент",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          object: "name",
          titleKey: "employee",
          title: "Сотрудник",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          full: true,
          key: "status",
          titleKey: "status_order",
          object: "name",
          title: "Статус заказа",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          full: true,
          key: "shop",
          titleKey: "shop",
          object: "name",
          title: "Магазин",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price_total",
          titleKey: "price_total",
          price: true,
          title: "Цена заказа",
        },
        {
          disableLink: true,
          key: "discounts",
          titleKey: "sale",
          object: "promotion_name",
          title: "Акция",
        },
        {
          key: "created_at",
          titleKey: "created_at",
          title: "Создан",
          dateTimeFormat: true,
          full: true,
        },
        {
          detail: true,
          log: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
